export default {"src":"/_next/static/media/real-time-monitoring.d86cf178.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};